<template>
  <div>
    <label>Letter Details</label>
    <history-details-key-value-list :values="keyValuePairs" class="mx-3" />

    <div v-if="mailParams">
      <label>Message Parameters:</label>
      <history-details-key-value-list :values="mailParams" class="mx-3" />
    </div>
  </div>

</template>

<script>
import HistoryDetailsKeyValueList from "./HistoryDetailsKeyValueList.vue";
import {amfx} from "../../framework/utils/amfx";
import { cobraConstants } from "../../cobra/cobra-constants";

export default {
  name: "PaperMailDetails",
  components: {HistoryDetailsKeyValueList},

  data() {
    return {

    }
  },
  props: {
    bag: { type: Object, required: true }
  },
  computed: {
    ...amfx.map("route", "participantId"),
    mailParams(){
      if (!this.bag.mailParams) return;

      return Object.entries( this.bag.mailParams).map(([key, value]) => {
        return { key, value };
      });
    },
    keyValuePairs() {
      const kvps = [];
      const mailStatusReversed = _.invert(cobraConstants.MAIL_STATUS);

       kvps.push({ key: "Letter", value: "Download", clickAction: () => this.downloadPaperMail(), icon: "fa-download" });
       kvps.push({ key: "Ameriflex Mail Job Status", value: mailStatusReversed[this.bag.status]});
       kvps.push({ key: "PostGrid Letter Id", value: this.bag.postGridLetterId});
       kvps.push({ key: "PostGrid Letter Status", value: this.bag.postGridLetterStatus});
       kvps.push({ key: "PostGrid Postal Status", value: this.bag.postGridPostalStatus});
       kvps.push({ key: "PostGrid Postal Tracking Number", value: this.bag.postGridPostalTrackingNumber});

      return kvps;
    }
  },
  methods: {
    async downloadPaperMail() {
      await romeApi.download(`/participant/${this.participantId}/papermail/download/${this.bag.paperMailMessageId}`);
    },
  },
}
</script>



<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/history/modals/PaperMailDetails.vue